import Grid from '@mui/material/Grid';

export const EmptyRow = () => {
    return <Grid item xs={12} style={{ padding: 0 }} />;
};
